import { useQueryClient } from "@tanstack/react-query";
import { useCheckMRDC } from "@/hooks/mrdc/use-check-mrdc";
import { usePollMRDC } from "@/hooks/mrdc/use-poll-mrdc";
import { useTenancy } from "@/hooks/tenancy/use-tenancy";
import { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

export function useCheckDepositDrawer() {
  const queryClient = useQueryClient();
  const history = useHistory();
  const location = useLocation();
  const { data: tenancy } = useTenancy();
  const [pollCount, setPollCount] = useState(0);
  const queryParams = new URLSearchParams(location.search);

  const { data: mrdc } = useCheckMRDC({
    status: "pending",
    retry: 0,
    // staleTime: 1000,
    onError: (error) => {
      if (error?.response?.status === 404) {
        queryClient.setQueryData(["mrdc", "pending"], []);
      }
    },
  });

  const { data: pollData } = usePollMRDC({
    id: mrdc?.[0]?.mrdc_id,
    retry: 0,
    onSuccess: () => {
      // toast.success("Your deposit was submitted!");
      queryClient.setQueryData(["mrdc", "pending"], []);
      queryClient.invalidateQueries(["mrdc"]);

      if (!isRestrictedRoute(location.pathname)) {
        if (queryParams.has("mrdc")) {
          queryParams.delete("mrdc");
          history.replace({
            search: queryParams.toString(),
          });
        }
      }
    },
    onError: (error) => {
      if (error.response?.status === 408) {
        queryClient.setQueryData(["mrdc", "pending"], []);
        queryClient.invalidateQueries(["mrdc"]);

        if (!isRestrictedRoute(location.pathname)) {
          if (!queryParams.has("mrdc_expired")) {
            queryParams.set("mrdc_expired", true);
          }
          if (queryParams.has("mrdc")) {
            queryParams.delete("mrdc");
          }

          history.replace({
            search: queryParams.toString(),
          });
        }
      }

      if (error?.response?.status === 504) {
        queryClient.invalidateQueries(["mrdc"]);
        setPollCount((prev) => (prev += 1));
      }
    },
  });

  const data = pollData || mrdc?.[0];

  const handleOpen = (id) => {
    if (!isRestrictedRoute(location.pathname)) {
      if (queryParams.has("mrdc")) {
        queryParams.delete("mrdc");
      }

      queryParams.set("mrdc", id);
      history.push({
        search: queryParams.toString(),
      });
    }
  };

  const handleClose = () => {
    if (data?.status === "pending") {
      return;
    }

    if (!isRestrictedRoute(location.pathname)) {
      if (queryParams.has("mrdc")) {
        queryParams.delete("mrdc");
        history.replace({
          search: queryParams.toString(),
        });
      }
    }
  };

  const isRestrictedRoute = (pathname) => {
    return pathname === "/signup" || pathname === "/login";
  };

  return {
    open:
      (queryParams.has("mrdc") && !isRestrictedRoute(location.pathname)) ||
      (data?.status === "pending" &&
        location.pathname !== "/mrdc" &&
        tenancy?.feature_flags?.mrdc),
    drawerData: data,
    handleClose,
    handleOpen,
    // ...rest,
  };
}
